import { render } from "./ClientBancosMovimientos.vue?vue&type=template&id=18e6555e&scoped=true"
import script from "./ClientBancosMovimientos.vue?vue&type=script&lang=js"
export * from "./ClientBancosMovimientos.vue?vue&type=script&lang=js"

import "./ClientBancosMovimientos.vue?vue&type=style&index=0&id=18e6555e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e6555e"]])

export default __exports__